module.exports = __webpack_public_path__ + "static/media/temp_25.13f85d8d.jpg";